import 'whatwg-fetch';
import React from 'react';
import {connect} from 'react-redux';
import {hashHistory} from 'react-router';

import api from '../utility/api';
import SpecialityForm from '../screens/create-speciality';
import {asyncStart, showFeedback, asyncEnd} from '../actions/application';

class CreateSpeciality extends React.Component {

  constructor() {
    super(...arguments);
    this.state = {
      speciality_title: ''
    };
  }

  displayFeedBack(message){
    this.props.dispatch(showFeedback({message: message}));
  }

  dispatch(action){
    this.props.dispatch(action());
  }

  handleSubmit(e) {

    e.preventDefault();
    
    const specialityTitle = this.state.speciality_title;
   

    this.props.dispatch(asyncStart());
    api.createSpeciality(specialityTitle)
      .then(() => {
        this.props.dispatch(showFeedback({message: "Your speciality has been added successfully."}));
        this.dispatch(asyncEnd);
        hashHistory.push('specialities');
      })
      .catch(error => {
        this.dispatch(asyncEnd);
        this.displayFeedBack(error.message);
      })

  }

  handleChange(field, e) {
    this.setState({[field]: e.target.value});
  }


  render() {
    return (
      <SpecialityForm
        state={this.state}
        handleChange={this.handleChange.bind(this)}
        handleSubmit={this.handleSubmit.bind(this)}
      />

    );
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user
  }
}

export default connect(mapStateToProps, null)(CreateSpeciality);


// WEBPACK FOOTER //
// ./src/containers/create-speciality.js